/**
 * Checks an element's position in respect to a HTMLElement
 * and determines wether it's within its boundaries.
 *
 * @param {node} element The DOM node you want to check
 * @return {boolean} A boolean value that indicates wether is on or off the container.
 */
function inContainer (element: HTMLElement, options : Options) {
    if (!element) {
        throw new Error('You should specify the element you want to test');
    }

    if (typeof element === 'string') {
        element = document.querySelector(element);
    }

    if (typeof options === 'string') {
        options = {
            tolerance: 0,
            container: document.querySelector(options)
        };
    }

    if (typeof options.container === 'string') {
        options.container = document.querySelector(options.container);
    }

    if (options instanceof HTMLElement) {
        options = {
            tolerance: 0,
            container: options
        };
    }

    if (!options.container) {
        throw new Error('You should specify a container element');
    }

    const containerRect = options.container.getBoundingClientRect();

    return (
        // // Check bottom boundary
        (element.offsetTop + element.clientHeight) - options.tolerance >
        options.container.scrollTop &&

        // Check right boundary
        (element.offsetLeft + element.clientWidth) - options.tolerance >
        options.container.scrollLeft &&

        // Check left boundary
        element.offsetLeft + options.tolerance <
        containerRect.width + options.container.scrollLeft &&

        // // Check top boundary
        element.offsetTop + options.tolerance <
        containerRect.height + options.container.scrollTop
    );
}

export default inContainer;
